/* stylelint-disable max-nesting-depth, selector-max-compound-selectors */

.ux-iws-stateful-tiles {
    max-width: 100%;
    margin: 0 auto;
}

/* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
